export default function menuAdd_getPageTemplates(myTemplates: any[], onAddPage: func) {
    const templatesOptions: any = []

    let isSeparatorAdded = false

    _.map(myTemplates, (template)=>{
        // add separator before templates
        if (!isSeparatorAdded && !!template.id) {
            isSeparatorAdded = true
            templatesOptions.push({
                type: 'separator'
            })
        }

        templatesOptions.push({
            icon    : template.icon,
            label   : template.title,
            onClick : ()=>onAddPage(template.id, template.typeId)
        })
    })

    return templatesOptions
}
